import { snapdom } from '@zumer/snapdom'

import palette from '@/styles/palette'

import { ShareType, SocialType } from '../utils'
import AssetDiamondHand from './assets/diamond-hand.png'
import AssetHodlTight from './assets/hodl-tight.png'
import ShareFaceBookChartDark from './assets/Share_Facebook_Chart_Dark.svg'
import ShareFaceBookLionDark from './assets/Share_Facebook_Lion_Dark.svg'
import ShareIGLionDark from './assets/Share_IG_Lion_Dark.svg'
import ShareTwitterLionDark from './assets/Share_Twitter_Lion_Dark.svg'
import AssetTheTech from './assets/the-tech.png'
import AssetToTheMoon from './assets/to-the-moon.png'
import AssetUpOnly from './assets/up-only.png'

/**
 * ShareType.Link would not use this function
 */
export function getBackgroundImage(socialType: SocialType, shareType: ShareType) {
  if (socialType === SocialType.instagram) {
    return ShareIGLionDark
  }
  if (socialType === SocialType.twitter) {
    return ShareTwitterLionDark
  }

  // Facebook social type
  if (shareType === ShareType.Lion) {
    return ShareFaceBookLionDark
  }
  return ShareFaceBookChartDark
}

type LionInfo = {
  lionDsc: string
  lionImage: string
}

const LION_INFOS: LionInfo[] = [
  {
    lionDsc: 'In it for the tech',
    lionImage: AssetTheTech.src,
  },
  {
    lionDsc: 'Diamond hands',
    lionImage: AssetDiamondHand.src,
  },
  {
    lionDsc: 'Hodl tight!',
    lionImage: AssetHodlTight.src,
  },
  {
    lionDsc: 'To the moon!',
    lionImage: AssetToTheMoon.src,
  },
  {
    lionDsc: 'Up only',
    lionImage: AssetUpOnly.src,
  },
]

const LION_INFO_RANGE = new Array(LION_INFOS.length - 1).fill(0).map((cur, i) => -0.3 + i * 0.2)

const getRangeIndex = (num: number, range: number[]) => {
  for (let i = 0; i < range.length; i += 1) {
    if (num < range[i]) return i
  }
  return range.length
}

export const getLionInfo = (priceChange: number): LionInfo =>
  LION_INFOS[getRangeIndex(priceChange, LION_INFO_RANGE)]

export const LION_DESC_COLOR = palette.blue[300]
export const SHARE_CHART_BACKGROUND =
  'linear-gradient(309.3deg, #303030 10.68%, #080C34 57.51%, #303030 103.86%)'

export const SHARE_CONTENT_SIZE_MAP = {
  [SocialType.twitter]: {
    w: 1200,
    h: 675,
  },
  [SocialType.instagram]: {
    w: 1080,
    h: 1920,
  },
  [SocialType.facebook]: {
    w: 1240,
    h: 1240,
  },
}

export const downLoadHTMLToImage = async ({
  dom,
  fileName,
}: {
  dom: HTMLElement
  fileName: string
}) => {
  if (!dom) return Promise.reject()
  const result = await snapdom(dom)

  await result.download({ format: 'jpg', filename: fileName })
}
